import { AxiosError } from 'axios';
import useApi from 'hook/useApi';
import useApiPath from 'hook/useApiPath';
import {
  useMutation as useMutationOriginal,
  UseMutationOptions,
} from 'react-query';

export enum METHOD {
  POST = 'post',
  PUT = 'put',
  DELETE = 'delete',
  PATCH = 'patch',
}

interface IMethod {
  method: METHOD.POST | METHOD.PUT | METHOD.DELETE | METHOD.PATCH;
}

export default function useMutation<T>(
  path: string,
  options: UseMutationOptions<unknown, AxiosError, T, unknown> & IMethod,
) {
  const api = useApi();
  const apiPath = useApiPath(); // apiPath
  const mutationApi = (params: T, pathParam?: string) => {
    let pathURL: string = apiPath + path;

    if (pathParam) {
      pathURL += pathParam;
    }

    if (options.method === METHOD.DELETE) {
      return api[options.method](`${pathURL}${params}`);
    }

    return api[options.method](pathURL, JSON.stringify(params), {
      headers: { 'Content-type': 'application/json' },
    });
  };

  return useMutationOriginal(mutationApi, {
    ...options,
  });
}
